// Pourquoi la console ne s'ouvre pas : la distinction est le tout.
//
// « denied » est une DÉCISION du serveur sur un compte connu (403). « unreachable » veut dire que
// le poste n'a jamais réussi à parler au serveur : réseau d'entreprise, pare-feu, proxy, VPN,
// coupure, DNS, ou 404 de Traefik pendant un redéploiement roulant de l'API. Les confondre envoie
// l'agent réclamer des droits qu'il possède déjà pendant que le vrai problème est sur son réseau.
import axios from "axios";

export type AccessFailure = "denied" | "unreachable";

/**
 * SEUL un 403 est un refus : le serveur a lu le jeton, reconnu le porteur et tranché.
 * Tout le reste décrit un chemin réseau qui n'aboutit pas.
 */
export function classifyAccessFailure(err: unknown): AccessFailure {
	return axios.isAxiosError(err) && err.response?.status === 403 ? "denied" : "unreachable";
}

/** Détail technique court, affiché à l'agent pour qu'il puisse le lire au service informatique. */
export function describeFailure(err: unknown): string {
	if (axios.isAxiosError(err)) {
		if (err.response) return `HTTP ${err.response.status}`;
		if (err.code) return err.code; // ERR_NETWORK, ECONNABORTED, ERR_CANCELED…
	}
	const message = String((err as any)?.error_description ?? (err as any)?.message ?? "").trim();
	return message.length > 0 ? message.slice(0, 120) : "erreur inconnue";
}

/** L'hôte que le poste doit pouvoir joindre : c'est CE nom qu'un pare-feu doit autoriser. */
export function apiHost(apiBase: string): string {
	try {
		return new URL(apiBase).host;
	} catch {
		return apiBase || "le serveur d'administration";
	}
}
